export const serializeModel = <T>(model: T): T =>
  JSON.parse(JSON.stringify(model));
